export default "data:application/octet-stream;base64,Lm1vZHVsZS1sYWJlbHMtbGlzdCB7CiAgZGlzcGxheTogZmxleDsKICBmbGV4LWRpcmVjdGlvbjogY29sdW1uOwp9Cg=="